import { commonConfig } from './common';
export const environment = Object.assign(Object.assign({}, commonConfig), { production: true, authContextId: '446', authGatewayUrl: 'https://rr-auth-gateway.savvasrealize.com/sapi', rbsConfig: {
        scope: 'rbs',
        clientId: 'xSiP7ZfpXOrjX6ErPbCPLJ5hgQ0jt47',
        grant_type: 'custom_castgc',
    }, ssoUrl: 'https://sso.rumba.pk12ls.com/sso', ssoLoginQueryParams: {
        k12int: true,
    }, errorRoute: 'error', authCallbackRoute: 'auth-callback', backendForFrontend: {
        url: 'https://realize-reports-overview-bff.realizereports.com',
        apiPath: '/graphql',
    } });
